import React from 'react'
import { Alert, Heading } from '@livechat/design-system-react-components'

import { alertWrapperCss } from './styles'

const NotProcessableAlert = () => (
  <Alert kind="warning" css={alertWrapperCss}>
    <Heading size="xs">Transaction already processed</Heading>
    You can no longer make operations. This transaction has already been
    processed.
  </Alert>
)

export default NotProcessableAlert
